import React from "react"
import clsx from "clsx"

import imgExample from "../../static/assets/add-example.gif"

const AdContainer = ({ className, ...props }) => {
  return (
    <div className={clsx(`flex center w-full mb-8`, className)} {...props}>
      <img src={imgExample} className="object-contain mx-auto" />
    </div>
  )
}

export default AdContainer
